import { jsx as a } from "react/jsx-runtime";
import { W as c, L as n } from "../index-CeQ14xPc.js";
import { c as i } from "../index-BNmRGtA6.js";
import { c as u } from "../clsx-OuTLNxxd.js";
import { B as m } from "../Badge-U9u-iOJu.js";
import '../Status.css';const l = "_status_zv215_1", O = "_success_zv215_5", r = {
  status: l,
  success: O
}, d = i(r.status, {
  variants: {
    status: {
      WON: r.success,
      LOST: r.error
    }
  },
  defaultVariants: {
    status: "WON"
  }
}), v = ({
  className: t,
  status: s,
  ...e
}) => {
  if (s !== "WON" && s !== "LOST") return null;
  const o = {
    WON: "primary",
    LOST: "error"
  };
  return /* @__PURE__ */ a(
    m,
    {
      "aria-label": `${s.toLowerCase()}-badge`,
      className: u(d({ status: s }), t),
      "data-cxy-name": "status",
      isRound: !0,
      size: "l",
      variant: o[s],
      ...e,
      children: s === "WON" ? /* @__PURE__ */ a(c, {}) : /* @__PURE__ */ a(n, {})
    }
  );
};
export {
  v as Status
};
